import React, {
  useRef,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import { getGeneralCategoriesById } from "../../../core/api/Api";
import { useParams, useLocation } from "react-router-dom";
import FeatureCard from "../../common/feature-card/FeatureCard";
import Loading from "../../common/loading/Loading";
import { useTranslation } from "react-i18next";
import { pngs } from "../../../core/constants/pngs";
import useLangNavigate from "../../common/useLangNavigate";
import { SERVICE_SESSION_ID } from "../../../core/constants/constants";
import "./GeneralCategories.css";

const GeneralCategories = () => {
  const { t } = useTranslation();
  let { service_id, flow_type } = useParams();
  const navigate = useLangNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const mounted = useRef(true);

  const write_mode = new URLSearchParams(location.search).get("write_mode");

  const goToQuestionCategoriesDetails = (item) => () => {
    if (item?.is_active) {
      navigate(
        "/general-categories-options/" +
          service_id +
          "/" +
          item?.id +
          "/" +
          flow_type +
          (write_mode ? "?write_mode=" + write_mode : "")
      );
    }
  };

  const GENERAL_CATEGORY_ORDER = [2, 4, 3];

  const getData = useCallback(() => {
    getGeneralCategoriesById(service_id)
      .then((res) => {
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          const sorted = [...data].sort((a, b) => {
            const ai = GENERAL_CATEGORY_ORDER.indexOf(a.id);
            const bi = GENERAL_CATEGORY_ORDER.indexOf(b.id);
            const aPos = ai === -1 ? Infinity : ai;
            const bPos = bi === -1 ? Infinity : bi;
            return aPos - bPos;
          });
          setData(sorted);
        }
      })
      .catch((e) => {});
  }, [service_id]);

  const page_title = useMemo(
    () =>
      t(
        flow_type === "reformulate"
          ? "what_project_to_bring_to_life"
          : "what_do_you_want_to_write_about"
      ) + "?",
    [t, flow_type]
  );

  const page_description = useMemo(
    () =>
      t(
        flow_type === "reformulate"
          ? "general_categories_page_description_reformulate"
          : "general_categories_page_description"
      ),
    [t, flow_type]
  );
  const onInit = useRef(true);

  useEffect(() => {
    if (!onInit.current) return;
    onInit.current = false;
    mounted.current = true;
    getData();
    return () => {
      mounted.current = false;
    };
  }, [getData]);

  if (data?.length === 0) {
    return <Loading />;
  }

  const imageMap = {
    [SERVICE_SESSION_ID.IS_ANOTHER_STORY]: pngs.writeAStory,
    [SERVICE_SESSION_ID.IS_SELF_DEV]: pngs.writeASelfDev,
    [SERVICE_SESSION_ID.IS_AUTOBIO]: pngs.autobiography,
  };

  return (
    <section
      className="aai-features py-100"
    >
      <div className="container mt-lg-5 mt-0">
        {" "}
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="aai-section-title mb-3 text-center mb-5">
              <h2 className="section-title">{page_title}</h2>
              <p className="section-desc">{page_description}</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {data?.map((item, index) => (
            <FeatureCard
              key={"service-" + index}
              onClick={goToQuestionCategoriesDetails(item)}
              img={imageMap[item.id] ?? null}
              name={item?.name}
              description={item?.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeneralCategories;
